import styled from 'styled-components';

const GCBodyContent = styled.div`
  flex-grow: 1;
  margin-left: 56px;
`;

export { GCBodyContent };
